import $ from 'jquery'
import { initASwap } from './aswap'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'


const onLoadingComplete = () => {
  initASwap()
  setTimeout(() => {
    document.documentElement.classList.remove("index-loading")
  }, 600)
}

const initIntro = (el) => {
  
  const bg = el.querySelector(".loading-bg")
  const iconWrapper = el.querySelector(".masked-wrapper")
  const svg = el.querySelector("svg")
  if (!bg || !svg || !iconWrapper) {
    onLoadingComplete()
    return;
  }
  const t = new TimelineMax({repeat: 0})
  TweenMax.set(iconWrapper, {opacity: 1, scale: .4})
  t.to(iconWrapper, .4, {x: 0, y: 0, opacity: 1, scale: 1, ease: Power3.easeOut})
  t.to(svg, 1, {opacity: 1, onComplete: onLoadingComplete})
  t.to(iconWrapper, .4, {y: -30, opacity: 0, ease: Power3.easeIn}, 1.5)
  t.to(bg, .4, {y: window.innerHeight, ease: Power3.easeIn}, 1.5)
  
  // onLoadingComplete()

}

export const loadingSequence = () => {
  const box = document.getElementById("box-loading")
  if (box) {
    initIntro(box)
  } else {
    onLoadingComplete()
  }
  
}